import styled from 'styled-components'
import MuiButton from '@material-ui/core/Button'

export const StyledButton = styled(MuiButton)`
  &.MuiButton-containedSizeSmall {
    min-height: 35px;
  }
`
